import { buildS3DownloadUrl } from 'services/s3Download'
import { isModularContentType } from 'utils'
import { trackEvent } from 'services/analytics'

export const UNFILED = 'unfiled'

export const buildFavoriteDragId = (favoriteId) => `favorite-${favoriteId}`
export const buildFolderDragId = (folderId) => `folder-${folderId}`

export const getItemMeta = (item) => {
  if (isModularContentType(item?.type)) {
    return [
      item?.type === 'partners-and-staffs' ? 'Partners and Staff' : 'Course',
      item?.lesson_title,
    ].filter(Boolean)
  }

  return [item?.document_type].filter(Boolean)
}

export const openFavoriteItem = (history, item) => {
  if (!item) return

  if (isModularContentType(item?.type)) {
    history.push(`/mode/${item.type}/${item.contentId}${item?.lesson ? `/${item.lesson}` : ''}`)
    return
  }

  const fileUrl = item?.document
  if (!fileUrl) return

  trackEvent('FILE_DOWNLOAD', {
    content_type: item?.type || item?.uid || 'favorite-file',
    content_id: item?.contentId || item?.documentId,
    resource_id: item?.documentId || item?.id,
    content_name: item?.title,
    source: 'favorites',
  })
  window.location.href = buildS3DownloadUrl({
    sourceUrl: fileUrl,
    filename: item?.title || item?.file || item?.document || 'arquivo',
  })
}
